import { employeeGroupsRoutes } from '@/router/time-tracking/employee-groups';
import { employeesRoutes } from '@/router/time-tracking/employees';

export default {
  path: '/time-tracking',
  name: 'time',
  component: () => import('@/views/PassThrough.vue'),
  children: [
    ...employeesRoutes,
    ...employeeGroupsRoutes,

    {
      path: 'default/:employeeUuid?/:date?',
      name: 'time-tracking-default',
      redirect: (to) => {
        if (to.params.employeeUuid) {
          return `/v3/time-tracking/in-and-out/${to.params.employeeUuid}`;
        }

        return '/v3/time-tracking/in-and-out';
      },
    },
    {
      path: 'list/:employeeUuid/:date',
      name: 'time-tracking',
      redirect: '/v3/time-tracking/in-and-out/:employeeUuid/:date',

    },
    {
      path: 'form/:employeeUuid/:activityUuid?',
      name: 'activity',
      redirect: (to) => {
        if (to.params.activityUuid) {
          return `/v3/time-tracking/in-and-out/${to.params.employeeUuid}/time-activity/${to.params.activityUuid}`;
        }

        return `/v3/time-tracking/in-and-out/${to.params.employeeUuid}/time-activity`;
      },
    },
  ],
};
